import React from 'react';

function Skills() {
  return (
    <section className="skills-section">
      <h2>My Skills</h2>

      <h3>Specialized</h3>
      <ul>
        <li>PHP</li>
        <li>React.js</li>
        <li>JQuery/Ajax</li>
        <li>Bootstrap</li>
        <li>JavaScript</li>
        <li>HTML/CSS</li>
        <li>MySQL</li>
      </ul>

      <h3>Others</h3>
      <ul>
        <li>Android Development with Java</li>
        <li>Node.js</li>
        <li>MS Office (Word, Excel, PowerPoint)</li>
        <li>Coreldraw</li>
        <li>React Native</li>
      </ul>
    </section>
  );
}

export default Skills;
